import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import LineClockIcon from 'LuxKit/Icons/line/LineClockIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

const MetadataRow = styled(Group)`
  padding: ${rem(4)} 0;
`

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: ${props => props.theme.palette.neutral.surface.lightForegroundAlt};
  flex-shrink: 0;
`

interface Props {
  duration?: string
  bookableUntilDate?: string
}

function ExperienceDetailMetadata({ duration, bookableUntilDate }: Props) {
  const intl = useIntl()

  return (
    <Group direction="vertical" gap={8}>
      {duration && (
        <MetadataRow direction="horizontal" gap={8} verticalAlign="center">
          <IconWrapper><LineClockIcon /></IconWrapper>
          <BodyText variant="medium">{duration}</BodyText>
        </MetadataRow>
      )}
      {bookableUntilDate && (
        <MetadataRow direction="horizontal" gap={8} verticalAlign="center">
          <IconWrapper><LineCalendarIcon /></IconWrapper>
          <BodyText variant="medium">
            {intl.formatMessage(
              {
                id: '6OzzcCWIjpk6n3UkjRIE',
                defaultMessage: 'Bookable until {date}',
                description: 'Label showing the booking deadline for an experience offer in the detail drawer',
              },
              { date: bookableUntilDate },
            )}
          </BodyText>
        </MetadataRow>
      )}
    </Group>
  )
}

export default ExperienceDetailMetadata
